import React, { useState } from 'react';
import { AGENTS } from '../agents.js';
import AgentMark from './AgentMark.jsx';
import * as roomApi from '../room-model.js';

export default function RecommendationCard({ projectId, rec, api = roomApi, onActivated, onDismissed, onDeclined }) {
  const [mandates, setMandates] = useState(() => Object.fromEntries((rec.items || []).map(i => [i.agent, i.mandate || ''])));
  const [briefs, setBriefs] = useState({});
  const [busy, setBusy] = useState(null);
  const [done, setDone] = useState({}); // agent -> 'activated' | 'declined'

  async function activate(agent) {
    setBusy(agent);
    try {
      await api.activateAgent(projectId, agent, { mandate: mandates[agent] || '', brief: briefs[agent] || '' });
      setDone(d => ({ ...d, [agent]: 'activated' }));
      if (onActivated) onActivated(agent);
    } finally { setBusy(null); }
  }
  async function decline(agent) {
    const note = window.prompt('Why skip this one? (optional)') || '';
    setBusy(agent);
    try {
      await api.declineAgent(projectId, agent, note);
      setDone(d => ({ ...d, [agent]: 'declined' }));
      if (onDeclined) onDeclined(agent);
    } finally { setBusy(null); }
  }
  async function dismiss() {
    const note = window.prompt('Dismiss the whole recommendation? Add a note for the Showrunner (optional)') || '';
    setBusy('__dismiss');
    try { await api.dismissRecommendation(projectId, rec._id, note); if (onDismissed) onDismissed(); }
    finally { setBusy(null); }
  }

  const advisory = rec.kind === 'push' || rec.kind === 'pause';
  const verb = rec.kind === 'pause' ? 'stand down' : rec.kind === 'push' ? 'keep working' : 'wake';
  return (
    <div className="rec-card">
      <div className="rec-head">
        <span className="mono-label">SHOWRUNNER</span>
        <span className="rec-kicker">recommends you {verb} {(rec.items || []).length} agent{(rec.items || []).length === 1 ? '' : 's'}</span>
        <button type="button" className="thread-link" style={{ marginLeft: 'auto' }} disabled={!!busy} onClick={dismiss}>Dismiss</button>
      </div>
      {rec.reasoning && <p className="rec-reason">{rec.reasoning}</p>}
      <div className="rec-agents">
        {(rec.items || []).map(item => {
          const a = AGENTS[item.agent];
          return (
            <div className="rec-agent" key={item.agent}>
              <div className="ra-head"><AgentMark agent={a} size="xs" /><span className="ra-name">{(a ? a.name : item.agent).toUpperCase()}</span></div>
              {!advisory && (
                <>
                  <label className="ra-l">Mandate</label>
                  <textarea className="ra-mandate" rows={2} value={mandates[item.agent] || ''} onChange={e => setMandates(m => ({ ...m, [item.agent]: e.target.value }))} />
                  <label className="ra-l">Your brief</label>
                  <input className="ra-brief" placeholder="Your brief to this agent (optional)" value={briefs[item.agent] || ''} onChange={e => setBriefs(b => ({ ...b, [item.agent]: e.target.value }))} />
                  <div className="ra-actions">
                    {done[item.agent]
                      ? <span className="ra-done">{done[item.agent] === 'declined' ? 'Declined' : 'Activated'}</span>
                      : <>
                          <button type="button" className="btn small accent" disabled={busy === item.agent} onClick={() => activate(item.agent)}>{busy === item.agent ? 'Waking…' : 'Activate'}</button>
                          <button type="button" className="btn small" disabled={busy === item.agent} onClick={() => decline(item.agent)}>Decline</button>
                        </>}
                  </div>
                </>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
